var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"MBookDemo"},[_c('b-button',{attrs:{"type":"is-primary"},on:{"click":_vm.openForm}},[_vm._v(" "+_vm._s(_vm.$t('forBusiness.getInTouch.learnMore'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }